import React from 'react'
import {
    FacebookIconButton,
    TwitterIconButton,
    InstagramIconButton,
    RSSIconButton,
    EmailIconButton,
    YoutubeIconButton,
} from 'component-library/buttons/IconButton/CommonIconButtons'
import { StyledSocialLinks } from './SocialLinks.styled'
import { ThemedRender } from 'component-library/__styling/themed-render'
import { colors } from 'component-library/__styling/settings'

export interface SocialLinks {
    facebook?: string
    twitter?: string
    instagram?: string
    youtube?: string
    rss?: string
    email?: string
}

export type Props = SocialLinks & {
    /* Used by sevennews */
    sectionTitle?: string
}

export const SocialLinks: React.FC<Props> = ({
    facebook,
    twitter,
    instagram,
    youtube,
    rss,
    email,
    sectionTitle,
}) => {
    return (
        <ThemedRender
            thewest={() => (
                <StyledSocialLinks>
                    {facebook && <FacebookIconButton link={facebook} />}
                    {twitter && <TwitterIconButton link={twitter} />}
                    {instagram && <InstagramIconButton link={instagram} />}
                    {youtube && <YoutubeIconButton link={youtube} />}
                    {rss && <RSSIconButton link={rss} />}
                    {email && <EmailIconButton link={email} />}
                </StyledSocialLinks>
            )}
            sevennews={() => {
                return (
                    <StyledSocialLinks className="hide-print">
                        {twitter && (
                            <TwitterIconButton
                                baseColor={colors.sevennewsSocial.twitter}
                                link={twitter}
                                title={getIconTitle('twitter', sectionTitle)}
                            />
                        )}
                        {facebook && (
                            <FacebookIconButton
                                link={facebook}
                                title={getIconTitle('facebook', sectionTitle)}
                            />
                        )}
                        {instagram && (
                            <InstagramIconButton
                                baseColor="radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)"
                                link={instagram}
                                title={getIconTitle('instagram', sectionTitle)}
                            />
                        )}
                        {youtube && (
                            <YoutubeIconButton
                                link={youtube}
                                title={getIconTitle('youtube', sectionTitle)}
                            />
                        )}
                        {rss && (
                            <RSSIconButton
                                baseColor={colors.sevennewsSocial.rss}
                                iconScale={0.5}
                                link={rss}
                                title={getIconTitle('rss', sectionTitle)}
                            />
                        )}
                        {email && (
                            <EmailIconButton
                                baseColor={colors.sevennewsSocial.email}
                                link={email}
                                title={getIconTitle('email', sectionTitle)}
                            />
                        )}
                    </StyledSocialLinks>
                )
            }}
        />
    )
}

export type IconType = 'youtube' | 'instagram' | 'facebook' | 'twitter' | 'rss' | 'email'

export const getIconTitle = (iconType: IconType, title?: string) => {
    if (title) {
        switch (iconType) {
            case 'youtube':
                return `Watch ${title} on YouTube`
            case 'instagram':
                return `Follow ${title} on Instagram`
            case 'facebook':
                return `Follow ${title} on Facebook`
            case 'twitter':
                return `Follow ${title} on Twitter`
            case 'rss':
                return `${title} RSS Feed`
            case 'email':
                return `Email ${title}`
            default:
                return undefined
        }
    }
    return undefined
}
